export const BATCH_JOB_STATUS = {
  initialized: 0,
  started: 1,
  finished: 2,
  failed: 9,
  systemError: 99,
} as const
